import React from "react"
import { compact } from "lodash"
import { Panel, Glyphicon } from "react-bootstrap"
import { Link } from "react-router"
import moment from "moment"

import Button from '../components/Button'
import HoverTip from '../components/HoverTip'
import { docHasWhichAdvertising } from "../../lib/advertisingTools";

const Timestamp = ({ ts }) => (
  <HoverTip text={ts}><span><Glyphicon glyph="time" /> {moment(ts).format("LL")}</span></HoverTip>
)

function DocumentedTrips({
  documentedTripsList,
  addNoPubliTag,
  noPubliTagId,
  Trips,
  showModal,
  partners
}) {
  return (
    documentedTripsList.map(docTrip => {
      const completeTrip = Trips[docTrip.tripId]
      return (
        <Panel className="actividad" style={{ margin: 20 }} key={docTrip.tripId}>
          <Panel.Heading className="trip-heading">
            <Panel.Title>
              {
                compact([completeTrip.name, completeTrip.realName])
                  .join(" / ")
              }
              <Link to={`/private/trip/${encodeURIComponent(docTrip.tripId)}`}>🔗</Link>
              {
                completeTrip.tags[noPubliTagId] && (
                  <HoverTip text="Este viaje no se tendrá en cuenta para ningún programa de publicidad.">
                    <div className="discarded">
                      Viaje excluido de publicidad
                    </div>
                  </HoverTip>
                )
              }
              {
                !completeTrip.tags[noPubliTagId] && (
                  <HoverTip text="No contar a este cliente a efectos de publicidad.">
                    <Button glyph="ban-circle" onClick={() => addNoPubliTag(docTrip.tripId)}>
                      No incluir a este cliente
                    </Button>
                  </HoverTip>
                )
              }
              
            </Panel.Title>
            <div>
            👤 {completeTrip.encargado}
            </div>
          </Panel.Heading>
          <Panel.Body>
            <p>De {completeTrip.startDate} a {completeTrip.endDate}</p>
            <p>Documentos generados:</p>
            <ul className="docsList">
              {
                docTrip.documents.map((doc, i) => (
                  <li key={doc._id}>
                    <Timestamp ts={doc.timestamp} />: {doc.doctype}
                    {/* {doc._id} */}
                    {/* {
                      docHasAnyAdvertising(doc, publiActivitiesSet) 
                      && (
                        <span className="hasit">✔️ Incluye publicidad</span>
                      )
                    } */}
                    {
                      docHasWhichAdvertising(doc, partners).map(partner => (
                        <span key={partner._id} className="hasit">✔️ {partner.name}</span>
                      ))
                    }
                    {
                      doc.doctype == "Propuesta" && (
                        <Button glyph="search" onClick={() => showModal(doc.tripId, i)}>
                          Detalles
                        </Button>
                      )
                    }
                    
                  </li>
                ))
              }
            </ul>
          </Panel.Body>
        </Panel>
      )
    })
  )
}

export default DocumentedTrips